import { useEffect } from 'react';
import { useLazyGetCultureIndexLocationChartsQuery } from 'services/api/Meteorology/Agro/CultureIndex/Location';
import { useHandleRequestErrors } from 'utils/hooks';
import { ResponseError } from 'services/api/base';
import { store } from 'redux/store';
import { setTriggerRequest } from 'redux/reducers/meteorologyAgroCultureIndexLocationReducer';
import useParams from './useParams';

export default function useCharts() {
  const params = useParams();

  const [trigger, { data, isFetching, error }] = useLazyGetCultureIndexLocationChartsQuery();

  useEffect(() => {
    store.dispatch(setTriggerRequest(params ? (() => trigger(params)) : undefined));
  }, [trigger, params]);

  useHandleRequestErrors(error as ResponseError);

  return { data, isFetching };
}
